export default __webpack_public_path__ + "static/media/a023-startup1-short.43ecb213.png";